import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '@/context/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { exchangeGoogleSession } = useAuth();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const hash = window.location.hash || '';
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;

    if (!sessionId) {
      nav('/login');
      return;
    }
    (async () => {
      try {
        await exchangeGoogleSession(sessionId);
        // remove the hash and go to dashboard
        window.history.replaceState({}, '', '/dashboard');
        toast.success('Signed in with Google.');
        nav('/dashboard');
      } catch {
        toast.error('Google sign-in failed.');
        nav('/login');
      }
    })();
  }, [exchangeGoogleSession, nav]);

  return (
    <main className="min-h-screen flex items-center justify-center bg-[#F7F5F4]">
      <div className="text-center">
        <div className="display text-2xl">Securing your session…</div>
        <p className="text-sm text-slate-500 mt-2 mono">Vigilant Entities · OAuth handshake</p>
      </div>
    </main>
  );
}
